import { render, staticRenderFns } from "./GitHooks.vue?vue&type=template&id=0736741a&scoped=true&"
import script from "./GitHooks.vue?vue&type=script&lang=js&"
export * from "./GitHooks.vue?vue&type=script&lang=js&"
import style0 from "./GitHooks.vue?vue&type=style&index=0&id=0736741a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0736741a",
  null
  
)

export default component.exports